import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { UserProfile } from '../../shared/types/user'
import { UserState } from './types'
import { clearUserServerCache, fetchUserById } from './userThunks'

const initialState: UserState = {
  profile: null,
  dossier: undefined,
  loading: false,
  error: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserProfile>) => {
      // this gets called when app starts, and checks firebase for existing/creating user
      const { uid, name, activeZoneId } = action.payload
      state.profile = {
        uid,
        name,
      }
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    clearUserProfile: (state) => {
      state.profile = null
      state.loading = false
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchUserById
      .addCase(fetchUserById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        console.log('dont fetching user by id', action.payload)
        state.loading = false
        // state.profile = action.payload ? (action.payload as UserProfile) : null
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      // cache
      .addCase(clearUserServerCache.fulfilled, (state, action) => {
        console.log('Cache cleared: ', action.payload)
      })
  },
})

export const { setUserProfile, clearUserProfile } = userSlice.actions

export default userSlice.reducer
